import { GLOBAL_LOADER_VALUE } from "../default_vals/enums";
import { store } from "@/vuex/store.js"

/**
 * Shows the global loader with an optional message.
 * @param {string} msg - The message to display.
 */
const showGlobalLoader = (msg = GLOBAL_LOADER_VALUE) => {
    store.state.main_loading_spinner = true;
    store.state.main_loading_spinner_text = msg;
}

/**
 * Hides the global loader.
 */
const hideGlobalLoader = () => {
    store.state.main_loading_spinner = false;
    store.state.main_loading_spinner_text = GLOBAL_LOADER_VALUE;
}

/**
 * @deprecated Use showGlobalLoader/hideGlobalLoader instead. Toggle logic can cause state issues.
 */
const switchGlobalLoaderState = (msg = GLOBAL_LOADER_VALUE) => {
    store.state.main_loading_spinner = !store.state.main_loading_spinner;
    store.state.main_loading_spinner_text = msg;
}

const switchGlobalLoaderMessage = (msg = GLOBAL_LOADER_VALUE) => {
    store.state.main_loading_spinner_text = msg;
}


export {
    switchGlobalLoaderState,
    switchGlobalLoaderMessage,
    showGlobalLoader,
    hideGlobalLoader
}